import { Phone, MessageCircle } from "lucide-react";
import { TEL_LINK, waLink, PHONE_DISPLAY } from "@/config/contact";

// Sticky belbalk mobiel: altijd zichtbaar vanaf het laden (alleen < md).
// Tracking blijft via de globale click-listener in App.js (tel:/wa.me hrefs +
// bestaande data-testid's => phone_click / whatsapp_click blijven vuren).
export default function StickyCTABar() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      data-cta-location="sticky_mobile"
      className="fixed bottom-0 left-0 w-full z-50 bg-[#0B1320] border-t border-white/10 p-3 pb-[calc(12px+env(safe-area-inset-bottom,0px))] flex items-center gap-3 md:hidden"
    >
      <a href={TEL_LINK} data-testid="sticky-call-button" className="js-phone bg-[#20C7C9] text-black font-bold h-12 rounded-lg flex-1 flex justify-center items-center gap-2 active:scale-95 transition-transform">
        <Phone className="w-5 h-5 shrink-0" /> Bel {PHONE_DISPLAY}
      </a>
      <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp-button" aria-label="App een foto via WhatsApp" className="bg-white text-black h-12 w-12 shrink-0 rounded-lg flex justify-center items-center active:scale-95 transition-transform">
        <MessageCircle className="w-5 h-5 shrink-0" />
      </a>
    </div>
  );
}
